import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { Overview } from './Overview';
import { Users } from './users';
//import { Lockers } from './lockers';

import { Reservations } from './reservations';

function Admin({ match }) {
  const { path } = match;

  return (
    <div className="card m-3">
      <div>
        <Switch>
          <Route exact path={path} component={Overview} />
          <Route path={`${path}/users`} component={Users} />
          <Route path={`${path}/reservations`} component={Reservations} />

        </Switch>
      </div>
    </div>
  );
}

export { Admin };